import { classNames, Component, h, tag } from "omi";

import { DocumentationTheme } from "@/api/models/documentationTheme.ts";
import { tailwind } from "@/tailwind";

type Props = {
  theme: DocumentationTheme | undefined;
};

@tag("nw-features-share-theme-preview")
export class BasePreviewImage extends Component<Props> {
  static css = [tailwind];

  render({ theme }: Props) {
    if (!theme) return null;
    return (
      <div
        className={classNames(
          "absolute -top-60 border flex items-center justify-center w-full z-40 h-60 rounded-2xl animate-fadeInFast duration-100 shadow-md overflow-hidden",
          { "bg-paper": theme === DocumentationTheme.LIGHT },
          { "bg-[#292524] border-leather": theme === DocumentationTheme.DARK },
          { "bg-paper": theme === DocumentationTheme.FUN },
        )}
      >
        {theme === DocumentationTheme.LIGHT && (
          <img
            src="/static/images/documentation/light-preview.svg"
            alt="Light theme preview"
            class={"h-52 rounded-xl inline-flex items-center justify-center"}
          />
        )}
        {theme === DocumentationTheme.DARK && (
          <img
            src="/static/images/documentation/dark-preview.svg"
            alt="Dark theme preview"
            class={"h-52 rounded-xl inline-flex items-center justify-center"}
          />
        )}
        {theme === DocumentationTheme.FUN && (
          <>
            <img
              src="/static/images/documentation/fun-preview-background.svg"
              alt="Fun theme background"
              class="absolute object-cover"
            />
            <img
              src="/static/images/documentation/fun-preview.svg"
              alt="Fun theme preview"
              class={"h-52 rounded-xl inline-flex items-center justify-center z-30"}
            />
          </>
        )}
      </div>
    );
  }
}
